/**
 * GSAP ScrollTrigger: sync body + shared PDP blocks to the section at viewport center
 * (mini-link-new style). Expects window.__enablePdpScrollSync set before load.
 * Optional window.__pdpScrollSyncSuffix for template-specific color maps (e.g. mini-link-new).
 */
(function () {
  if (!window.__enablePdpScrollSync) return;
  delete window.__enablePdpScrollSync;

  var templateSuffix = window.__pdpScrollSyncSuffix || '';
  delete window.__pdpScrollSyncSuffix;

  var miniLinkNewProfile = templateSuffix === 'mini-link-new';

  /** Dedupe applies from scroll listener (wheel + scrollbar share same logic). */
  var lastAppliedCenterRef;

  function injectTransitionCss() {
    if (document.getElementById('pdp-scroll-sync-transitions')) return;
    var s = document.createElement('style');
    s.id = 'pdp-scroll-sync-transitions';
    s.textContent =
      'body{-webkit-transition:background .4s linear;transition:background .4s linear}' +
      '.feature_section_block,.feature_section_block .feature_content_wrapper,.product_360_section,.instax-mini-cine-fp-section,.lifestyle-images-section{-webkit-transition:background-color .4s linear;transition:background-color .4s linear}' +
      '.feature_title_front{-webkit-transition:opacity .4s linear,-webkit-text-stroke-color .4s linear;transition:opacity .4s linear,-webkit-text-stroke-color .4s linear}' +
      '.feature_title_back,.product_360_title{-webkit-transition:opacity .4s linear,color .4s linear;transition:opacity .4s linear,color .4s linear}' +
      '.mini_c_heading,.mini_c_text{-webkit-transition:color .4s linear;transition:color .4s linear}' +
      '.feature_section_block .feature_content_wrapper,.feature_section_block h2.feature_heading,.feature_section_block .feature_description{-webkit-transition:background-color .4s linear,color .4s linear;transition:background-color .4s linear,color .4s linear}' +
      '.mini_showcase_box{-webkit-transition:background-color .4s linear;transition:background-color .4s linear}';
    document.head.appendChild(s);
  }

  function getPdpSyncLabel(el) {
    if (el.classList.contains('lifestyle-images-section')) return '__lifestyle__';
    var back = el.querySelector('.feature_title_back span');
    if (back) return (back.textContent || '').replace(/\s+/g, ' ').trim();
    var t360 = el.querySelector('.product_360_title span');
    if (t360) return (t360.textContent || '').replace(/\s+/g, ' ').trim();
    return '';
  }

  function collectColors(el) {
    el.removeAttribute('data-pdp-sync-heading');

    if (miniLinkNewProfile && el.classList.contains('lifestyle-images-section')) {
      el.setAttribute('data-pdp-sync-bg', '#eeeeee');
      el.setAttribute('data-pdp-sync-title', '#404042');
      el.setAttribute('data-pdp-sync-text', '#404042');
      return;
    }

    if (miniLinkNewProfile && el.classList.contains('instax-mini-cine-fp-section')) {
      var cineBg = getComputedStyle(el).backgroundColor;
      el.setAttribute('data-pdp-sync-bg', cineBg || '');
      el.setAttribute('data-pdp-sync-title', '#ffffff');
      el.setAttribute('data-pdp-sync-text', '#ffffff');
      return;
    }

    var bg = getComputedStyle(el).backgroundColor;
    var titleColor = '';
    var textColor = '';

    if (el.classList.contains('product_360_section')) {
      var tEl = el.querySelector('.product_360_title');
      var h2 = el.querySelector('.mini_c_heading');
      var txt = el.querySelector('.mini_c_text');
      titleColor = tEl ? getComputedStyle(tEl).color : '';
      textColor = h2 ? getComputedStyle(h2).color : txt ? getComputedStyle(txt).color : '';
    } else {
      var back = el.querySelector('.feature_title_back');
      var cw = el.querySelector('.feature_content_wrapper');
      titleColor = back ? getComputedStyle(back).color : '';
      textColor = cw ? getComputedStyle(cw).color : '';
    }

    el.setAttribute('data-pdp-sync-bg', bg || '');
    el.setAttribute('data-pdp-sync-title', titleColor || '');
    el.setAttribute('data-pdp-sync-text', textColor || '');
  }

  function applyMiniLinkNewOverrides(sections) {
    if (!miniLinkNewProfile) return;
    sections.forEach(function (el) {
      if (el.classList.contains('lifestyle-images-section')) return;
      if (el.classList.contains('instax-mini-cine-fp-section')) {
        el.setAttribute('data-pdp-sync-bg', '#FF4D33');
        el.setAttribute('data-pdp-sync-title', '#ffffff');
        el.setAttribute('data-pdp-sync-text', '#ffffff');
        return;
      }
      var label = getPdpSyncLabel(el);
      if (label === 'Frame Simulation') {
        el.setAttribute('data-pdp-sync-bg', '#002E23');
        el.setAttribute('data-pdp-sync-title', '#D9FFFF');
        el.setAttribute('data-pdp-sync-heading', '#FF4D33');
        el.setAttribute('data-pdp-sync-text', '#ffffff');
      } else if (/design focus/i.test(label)) {
        el.setAttribute('data-pdp-sync-bg', '#FF4D33');
        el.setAttribute('data-pdp-sync-title', '#ffffff');
        el.setAttribute('data-pdp-sync-text', '#ffffff');
      }
    });

    /** Keep Frame Simulation palette on all feature rows until Design Focus (360) is reached. */
    var frameIdx = -1;
    var designIdx = -1;
    for (var i = 0; i < sections.length; i++) {
      var lab = getPdpSyncLabel(sections[i]);
      if (lab === 'Frame Simulation') frameIdx = i;
      if (sections[i].classList.contains('product_360_section') && /design focus/i.test(lab)) {
        designIdx = i;
      }
    }
    if (frameIdx !== -1 && designIdx !== -1 && designIdx > frameIdx) {
      for (var j = frameIdx + 1; j < designIdx; j++) {
        var between = sections[j];
        if (between.classList.contains('feature_section_block')) {
          between.setAttribute('data-pdp-sync-bg', '#002E23');
          between.setAttribute('data-pdp-sync-title', '#D9FFFF');
          between.setAttribute('data-pdp-sync-heading', '#FF4D33');
          between.setAttribute('data-pdp-sync-text', '#ffffff');
        }
      }
    }

    var iqIdx = -1;
    var lifeIdx = -1;
    var parallaxIdx = -1;
    for (var m = 0; m < sections.length; m++) {
      var labM = getPdpSyncLabel(sections[m]);
      if (labM === 'Image Quality') iqIdx = m;
      if (sections[m].classList.contains('lifestyle-images-section')) lifeIdx = m;
      if (sections[m].classList.contains('instax-mini-cine-fp-section')) parallaxIdx = m;
    }

    /** Red feature rows after film parallax until Image Quality (e.g. UI Modes, Powered Up). */
    if (parallaxIdx !== -1 && iqIdx !== -1 && iqIdx > parallaxIdx) {
      for (var r = parallaxIdx + 1; r < iqIdx; r++) {
        var afterParallax = sections[r];
        if (afterParallax.classList.contains('feature_section_block')) {
          afterParallax.setAttribute('data-pdp-sync-bg', '#FF4D33');
          afterParallax.setAttribute('data-pdp-sync-title', '#ffffff');
          afterParallax.removeAttribute('data-pdp-sync-heading');
          afterParallax.setAttribute('data-pdp-sync-text', '#ffffff');
        }
      }
    }

    /** Mint band: Image Quality through last feature before lifestyle (#D9FFFF + #262626 copy). */
    function paintMintThroughLifestyle(el) {
      if (!el.classList.contains('feature_section_block')) return;
      el.setAttribute('data-pdp-sync-bg', '#D9FFFF');
      el.setAttribute('data-pdp-sync-title', '#ff4d33');
      el.setAttribute('data-pdp-sync-heading', '#262626');
      el.setAttribute('data-pdp-sync-text', '#262626');
    }
    if (iqIdx !== -1 && lifeIdx !== -1 && lifeIdx > iqIdx) {
      for (var k = iqIdx; k < lifeIdx; k++) {
        paintMintThroughLifestyle(sections[k]);
      }
    } else if (iqIdx !== -1) {
      paintMintThroughLifestyle(sections[iqIdx]);
    }
  }

  function setSyncedHeadingColor(el, value) {
    if (value) {
      el.style.setProperty('color', value, 'important');
    } else {
      el.style.removeProperty('color');
    }
  }

  /** Theme uses `.feature_content_wrapper div { color: … !important }`; match on wrapper + descendants. */
  function setSyncedDescriptionColor(rootEl, value) {
    function apply(el) {
      if (value) {
        el.style.setProperty('color', value, 'important');
      } else {
        el.style.removeProperty('color');
      }
    }
    apply(rootEl);
    rootEl.querySelectorAll('*').forEach(apply);
  }

  function applyFromSection(sectionEl) {
    var bg = sectionEl.getAttribute('data-pdp-sync-bg');
    var tc = sectionEl.getAttribute('data-pdp-sync-title');
    var hc = sectionEl.getAttribute('data-pdp-sync-heading');
    var tx = sectionEl.getAttribute('data-pdp-sync-text');
    if (!bg) return;

    document.body.style.background = bg;

    document.querySelectorAll('.feature_section_block').forEach(function (n) {
      n.style.backgroundColor = bg;
    });
    document.querySelectorAll('.feature_section_block .feature_content_wrapper').forEach(function (n) {
      n.style.backgroundColor = bg;
      if (hc) {
        n.style.color = '';
      } else if (tx) {
        n.style.color = tx;
      } else {
        n.style.color = '';
      }
    });
    document.querySelectorAll('.feature_section_block h2.feature_heading').forEach(function (n) {
      setSyncedHeadingColor(n, hc || '');
    });
    document.querySelectorAll('.feature_section_block .feature_description').forEach(function (n) {
      if (hc && tx) {
        setSyncedDescriptionColor(n, tx);
      } else {
        setSyncedDescriptionColor(n, '');
      }
    });
    document.querySelectorAll('.product_360_section').forEach(function (n) {
      n.style.backgroundColor = bg;
    });
    document.querySelectorAll('.mini_showcase_box').forEach(function (n) {
      n.style.backgroundColor = bg;
    });
    document.querySelectorAll('.instax-mini-cine-fp-section').forEach(function (n) {
      n.style.backgroundColor = bg;
    });
    document.querySelectorAll('.lifestyle-images-section').forEach(function (n) {
      n.style.backgroundColor = bg;
    });

    document.querySelectorAll('.feature_title_front').forEach(function (n) {
      if (tc) {
        n.style.setProperty('-webkit-text-stroke-color', tc, 'important');
      } else {
        n.style.removeProperty('-webkit-text-stroke-color');
      }
    });
    document.querySelectorAll('.feature_title_back').forEach(function (n) {
      if (tc) {
        n.style.setProperty('color', tc, 'important');
      } else {
        n.style.removeProperty('color');
      }
    });
    document.querySelectorAll('.product_360_title').forEach(function (n) {
      if (tc) {
        n.style.setProperty('color', tc, 'important');
      } else {
        n.style.removeProperty('color');
      }
    });
    document.querySelectorAll('.mini_c_heading').forEach(function (n) {
      if (hc) {
        setSyncedHeadingColor(n, hc);
      } else if (tx) {
        n.style.color = tx;
      } else {
        n.style.removeProperty('color');
      }
    });
    document.querySelectorAll('.mini_c_text').forEach(function (n) {
      if (tx) {
        n.style.color = tx;
      } else {
        n.style.color = '';
      }
    });
  }

  /** When viewport center is not inside any tracked row (e.g. hero / video). */
  function applyMiniLinkNewNeutralAtCenter() {
    applyFromSection({
      getAttribute: function (name) {
        if (name === 'data-pdp-sync-bg') return '#D9FFFF';
        if (name === 'data-pdp-sync-title') return '#ff4d33';
        if (name === 'data-pdp-sync-heading') return '';
        if (name === 'data-pdp-sync-text') return '#262626';
        return '';
      }
    });
  }

  /** Below lifestyle grid: footer-ish bands (explore film, specs, etc.) not in sync list. */
  function applyMiniLinkPostLifestyleAtCenter() {
    applyFromSection({
      getAttribute: function (name) {
        if (name === 'data-pdp-sync-bg') return '#eeeeee';
        if (name === 'data-pdp-sync-title') return '#404042';
        if (name === 'data-pdp-sync-heading') return '';
        if (name === 'data-pdp-sync-text') return '#404042';
        return '';
      }
    });
  }

  function getLifestyleBottomDocumentY(sections) {
    var maxBottom = null;
    for (var i = 0; i < sections.length; i++) {
      if (!sections[i].classList.contains('lifestyle-images-section')) continue;
      var rect = sections[i].getBoundingClientRect();
      var bottom = window.scrollY + rect.top + rect.height;
      if (maxBottom === null || bottom > maxBottom) maxBottom = bottom;
    }
    return maxBottom;
  }

  var POST_LIFESTYLE_REF = '__post_lifestyle__';

  function fireForSectionAtCenter(sections) {
    var centerY = window.scrollY + window.innerHeight / 2;
    var hit = null;
    for (var i = 0; i < sections.length; i++) {
      var section = sections[i];
      var rect = section.getBoundingClientRect();
      var top = window.scrollY + rect.top;
      var bottom = top + rect.height;
      if (top <= centerY && bottom >= centerY) {
        hit = section;
        break;
      }
    }
    if (hit) {
      if (lastAppliedCenterRef === hit) return;
      lastAppliedCenterRef = hit;
      applyFromSection(hit);
      return;
    }
    if (miniLinkNewProfile) {
      var lifeBottomY = getLifestyleBottomDocumentY(sections);
      if (lifeBottomY !== null && centerY > lifeBottomY) {
        if (lastAppliedCenterRef === POST_LIFESTYLE_REF) return;
        lastAppliedCenterRef = POST_LIFESTYLE_REF;
        applyMiniLinkPostLifestyleAtCenter();
        return;
      }
      if (lastAppliedCenterRef === null) return;
      lastAppliedCenterRef = null;
      applyMiniLinkNewNeutralAtCenter();
    }
  }

  function refreshSectionColors(sections) {
    lastAppliedCenterRef = undefined;
    sections.forEach(collectColors);
    applyMiniLinkNewOverrides(sections);
  }

  function boot() {
    if (!window.gsap || !window.ScrollTrigger) return;

    injectTransitionCss();
    window.gsap.registerPlugin(window.ScrollTrigger);

    var main = document.getElementById('MainContent');
    if (!main) return;

    var selector = '.feature_section_block, .product_360_section';
    if (miniLinkNewProfile) {
      selector += ', .lifestyle-images-section, .instax-mini-cine-fp-section';
    }

    var sections = [];
    main.querySelectorAll(selector).forEach(function (el) {
      sections.push(el);
    });

    if (!sections.length) return;

    window.requestAnimationFrame(function () {
      refreshSectionColors(sections);
      fireForSectionAtCenter(sections);
    });

    sections.forEach(function (section) {
      window.ScrollTrigger.create({
        trigger: section,
        start: 'top center',
        end: 'top center+=1',
        onEnter: function () {
          fireForSectionAtCenter(sections);
        },
        invalidateOnRefresh: true
      });
      window.ScrollTrigger.create({
        trigger: section,
        start: 'bottom center',
        end: 'bottom center+=1',
        onEnterBack: function () {
          fireForSectionAtCenter(sections);
        },
        invalidateOnRefresh: true
      });
    });

    var ro = new ResizeObserver(function () {
      window.ScrollTrigger.refresh();
    });
    sections.forEach(function (sec) {
      ro.observe(sec);
    });

    /**
     * ScrollTrigger onEnter uses ~1px bands; dragging the scrollbar can skip them.
     * Re-evaluate from viewport center on every scroll (rAF-throttled).
     */
    var scrollSyncRaf = 0;
    function onScrollSyncColors() {
      if (scrollSyncRaf) return;
      scrollSyncRaf = window.requestAnimationFrame(function () {
        scrollSyncRaf = 0;
        fireForSectionAtCenter(sections);
      });
    }
    window.addEventListener('scroll', onScrollSyncColors, { passive: true });

    window.addEventListener('load', function () {
      window.ScrollTrigger.refresh();
      refreshSectionColors(sections);
      fireForSectionAtCenter(sections);
    });
  }

  function waitForGsap() {
    var n = 0;
    var id = setInterval(function () {
      n++;
      if (window.gsap && window.ScrollTrigger) {
        clearInterval(id);
        boot();
      } else if (n > 200) {
        clearInterval(id);
      }
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForGsap);
  } else {
    waitForGsap();
  }
})();
